import React from 'react';
import {Col, FormCheck, FormLabel, Row} from 'react-bootstrap';
import {Field, useFormikContext} from 'formik';
import SelectField from '../../elements/ReactSelect/SelectField';
import {
    deathPermanentDisabilityOptions, documentsProtectionOptions,
    hospitalStayOptions, legalAidOptions,
    personalExpensesOptions, personalLuggageOptions,
    rescueCostsOptions, thirdPartiesLiabilityOptions
} from "../../../utils.js";
import Card from "../../elements/ReactBootstrap/Card.jsx";

const TravelAssistanceOfferWidgetAdditionalInformation = () => {
    const {isSubmitting} = useFormikContext();

    return (<Card header="Допълнителни покрития" collapse headerClassName='card-outline card-warning' initialClosed>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4 g-3">
        <Col>
            <FormLabel htmlFor="rescueCosts">Спасителни разноски</FormLabel>
            <Field component={SelectField} name="rescueCosts"
                   options={rescueCostsOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="deathPermanentDisability">Смърт и трайно намалена работоспособност</FormLabel>
            <Field component={SelectField} name="deathPermanentDisability"
                   options={deathPermanentDisabilityOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="hospitalStay">Дневни пари за болничен престой</FormLabel>
            <Field component={SelectField} name="hospitalStay"
                   options={hospitalStayOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="personalExpenses">Лични разходи</FormLabel>
            <Field component={SelectField} name="personalExpenses"
                   options={personalExpensesOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="personalLuggage">Кражба, загуба или забавяне на личен багаж</FormLabel>
            <Field component={SelectField} name="personalLuggage"
                   options={personalLuggageOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="documentsProtection">Разходи за откраднати/изгубени документи</FormLabel>
            <Field component={SelectField} name="documentsProtection"
                   options={documentsProtectionOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="thirdPartiesLiability">Гражданска отговорност към трети лица</FormLabel>
            <Field component={SelectField} name="thirdPartiesLiability"
                   options={thirdPartiesLiabilityOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormLabel htmlFor="legalAid">Правна помощ</FormLabel>
            <Field component={SelectField} name="legalAid"
                   options={legalAidOptions} disabled={isSubmitting} isClearable={true}
            />
        </Col>
        <Col>
            <FormCheck as={Field} name="flightPackage" id="flightPackage"
                       label="Пакет „Полет” - само за Дженерали" disabled={isSubmitting}>
            </FormCheck>
            <FormCheck as={Field} name="onTheWayPackage" id="onTheWayPackage"
                       label="Пакет „На път” - само за Дженерали" disabled={isSubmitting}>
            </FormCheck>
        </Col>
    </Row>
    </Card>);
};

export default TravelAssistanceOfferWidgetAdditionalInformation;
